import { ConfigProvider, Input, Modal, notification, Radio, Table } from 'antd'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { getApplyFormFields, updateExamApplyFieldList } from '../../common/request'
import ResponseCode from '../../common/response-code'
import { useSelector } from 'react-redux'

const AppChooseExamApplyField = forwardRef(({ modalTitle = '选择引用的字段', fieldList, insertSuccess }, ref) => {
  const dictInfo = useSelector(state => state.dict.dictInfo)
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const [notifyApi, contextHolder] = notification.useNotification()
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [searchKey, setSearchKey] = useState('')
  const [selectedRowItems, setSelectedRowItems] = useState([])
  const [radioKey, setRadioKey] = useState('')
  const [examId, setExamId] = useState('')

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  useEffect(() => {
    if (examId && modalVisible) {
      getTableData()
    }
  }, [examId, modalVisible])

  const columns = [
    {
      title: '字段名称',
      dataIndex: 'fieldName',
      key: 'fieldName'
    },
    {
      title: '字段编码',
      dataIndex: 'fieldCode',
      key: 'fieldCode'
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      render: (record) => {
        return dictInfo['sys_fieldKind'].find(item => {
          return item.dictValue === record
        })?.dictLabel
      }
    },
    {
      title: '表单类型',
      dataIndex: 'fieldFromType',
      key: 'fieldFromType',
      render: (record) => {
        return Number(record) === 2 ? '报名字段' : '职位字段'
      }
    }
  ]

  const getTableData = () => {
    setLoading(true)

    getApplyFormFields({ examId: examId }).then(res => {
      if (res.code === ResponseCode.success) {
        setTableData([].concat(res.data.applyFileFields || [], res.data.applyFormFields || []).filter(item => {
          return !fieldList.map(field => {
            return field.fieldCode
          }).includes(item.fieldCode)
        }))
      } else {
        Modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '查询考试报名字段失败'
      })
    }).finally(() => {
      setLoading(false)
    })
  }

  const showModal = (examId) => {
    setExamId(examId)
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    setSelectedRowKeys([])
    setSelectedRowItems([])
  }

  const onCancel = () => {
    setModalVisible(false)
  }

  const onOk = () => {
    setLoading(true)
    const params = {
      examId: selectedExam.id,
      fieldsList: selectedRowItems.filter(item => {
        return item.fieldType !== '11'
      }),
      fileFieldsList: selectedRowItems.filter(item => {
        return item.fieldType === '11'
      }).map(item => {
        return {
          ...item,
          fileSize: String(item.fileSize)
        }
      })
    }

    updateExamApplyFieldList(params).then(res => {
      setLoading(false)
      if (res.code === ResponseCode.success) {
        notifyApi.success({
          message: '操作成功'
        })

        hideModal()
        insertSuccess && insertSuccess()
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      setLoading(false)
      Modal.error({
        title: '网络错误',
        content: '设置报名字段失败',
        centered: true
      })
    })
  }

  const filterTableData = (list, radio, name) => {
    return list.filter(item => {
      switch (radio) {
        case 'applyFields':
          return item.fieldFromType === '2'
          break
        case 'positionFields':
          return item.fieldFromType === '1'
          break
        case 'fileFormField':
          return item.fieldType === '11'
          break
        default:
          return true
      }
    }).filter(item => {
      if (name) {
        return item.fieldName.indexOf(name) > -1
      } else {
        return true
      }
    })
  }

  const onSearchInput = (e) => {
    setSearchKey(e.target.value)
  }

  const handleSearch = (value) => {
    setSearchKey(value)
  }

  const onSelectedChange = (keys, items) => {
    setSelectedRowKeys(keys)
    setSelectedRowItems(items)
  }

  const radioKeyChange = (e) => {
    setSearchKey('')
    setRadioKey(e.target.value)
  }

  return (
    <>
      { contextHolder }
      <Modal
        width={ 680 }
        title={ modalTitle }
        open={ modalVisible }
        onOk={ onOk }
        onCancel={ onCancel }
      >
        <div className={ 'mb-3 d-flex align-items-center justify-content-between' }>
          <div className={ 'd-flex align-items-center' }>
            <span>筛选：</span>
            <Radio.Group
              value={ radioKey }
              size={ 'small' }
              onChange={ radioKeyChange }
              buttonStyle="solid"
            >
              <Radio.Button value={ '' }>全部</Radio.Button>
              <Radio.Button value={ 'applyFields' }>报名字段</Radio.Button>
              <Radio.Button value={ 'positionFields' }>职位字段</Radio.Button>
              <Radio.Button value={ 'fileFormField' }>附件</Radio.Button>
            </Radio.Group>
          </div>

          <Input.Search
            value={ searchKey }
            placeholder={ '请输入字段名或代码搜索' }
            onInput={ onSearchInput }
            onSearch={ handleSearch }
            style={ { width: '280px' } }
          >
          </Input.Search>
        </div>
        <ConfigProvider componentSize={ 'small' }>
          <Table
            loading={ loading }
            columns={ columns }
            dataSource={ filterTableData(tableData, radioKey, searchKey) }
            scroll={ {
              y: 400
            } }
            rowSelection={ {
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectedChange
            } }
            pagination={ false }
            rowKey={ record => record.fieldCode }
          ></Table>
        </ConfigProvider>
      </Modal>
    </>
  )
})

export default AppChooseExamApplyField
